let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bxYVx")).then(() => parcelRequire('3usyN'));